import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { Tabs, Tab } from "react-bootstrap";
import { ENDPOINT } from "../../constants/endpointConstants";
import { getRangeDates, getToken, formatDateTime } from "../../utils/utils";
import axios from "axios";
import Tile from "../../components/Tile";
import ReportInsightContainer from "../../components/ReportInsightContainer";
import InsightCategories from "./components/insight-categories";
import InsightProducts from "./components/insight-products";
import InsightSalesOvertime from "./components/insight-sales-overtime";
import InsightAverageTicket from "./components/insight-average-ticket";
import InsightLocalVsDelivery from "./components/insight-local-vs-delivery";
import InsightTopProducts from "./components/insight-top-products";
import InsightTopProductCategories from "./components/insight-top-product-categories";
import InsightSalesTable from "./components/insight-sales-table";
import InsightExpensesTable from "./components/insight-expenses-table";
import "./report-page.css";

const ReportPage = () => {
  const [dateRange, setDateRange] = useState(
    getRangeDates(new Date(), new Date())
  );
  const [volumeSummary, setVolumeSummary] = useState(null);
  const [activeTab, setActiveTab] = useState("datos");
  const [startDate, endDate] = dateRange;

  const daysInRange =
    startDate && endDate
      ? Math.ceil(
          (new Date(endDate).setHours(0, 0, 0, 0) -
            new Date(startDate).setHours(0, 0, 0, 0)) /
            (1000 * 60 * 60 * 24)
        ) + 1
      : 0;

  useEffect(() => {
    const token = getToken();
    getVolumeSummary(startDate, endDate, token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const datePickerOnChange = (update) => {
    setDateRange(update);
    if (update[0] && update[1]) {
      const token = getToken();
      getVolumeSummary(update[0], update[1], token);
    }
  };

  const getVolumeSummary = async (dateInit, dateFinish, token) => {
    const [dateInitFormatted, dateFinishFormatted] = getRangeDates(
      dateInit,
      dateFinish
    );
    const { data } = await axios.post(
      ENDPOINT.POST_VOLUME_SUMMARY,
      {
        startDate: formatDateTime(dateInitFormatted),
        endDate: formatDateTime(dateFinishFormatted),
      },
      token
    );
    setVolumeSummary(data.summary);
  };

  return (
    <div className="mx-5">
      <div className="d-flex justify-content-center gap-5 mt-4 flex-wrap">
        <div className="d-flex align-items-center">
          <h1 className="style-title-page"> Reporte </h1>
        </div>
        <div>
          <p className="mb-1">Fecha:</p>
          <div className="date-picker-container">
            <DatePicker
              selectsRange={true}
              startDate={startDate}
              dateFormat="yyyy/MM/dd"
              endDate={endDate}
              onChange={datePickerOnChange}
            />
          </div>
        </div>
      </div>
      {volumeSummary && (
        <div className="tite-containers d-flex justify-content-center flex-wrap">
          <Tile
            title="Total Ventas"
            value={volumeSummary.totalSalesVolume}
            valueType={"currency"}
          />
          <Tile
            title="Total Gastos"
            value={volumeSummary.totalExpenses}
            valueType={"currency"}
          />
          <Tile
            title="Ptos. Principales"
            value={volumeSummary.totalMainProducts}
          />
          <Tile
            title="Total Domicilios"
            value={volumeSummary.totalDeliveryVolume}
            valueType={"currency"}
          />
          <Tile
            title="Total Descuentos"
            value={volumeSummary.totalDiscountVolume}
            valueType={"currency"}
          />
        </div>
      )}

      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-5 mt-3 report-tabs"
      >
        <Tab eventKey="datos" title="Datos">
          {volumeSummary?.totalSalesVolume > 0 && (
            <div className="insights-container d-flex flex-wrap gap-4 mt-5">
              {daysInRange > 1 && (
                <ReportInsightContainer title="Ventas Por Dia">
                  <div className="chart-container">
                    <InsightSalesOvertime
                      startDate={startDate}
                      endDate={endDate}
                    />
                  </div>
                </ReportInsightContainer>
              )}
              {daysInRange > 1 && (
                <ReportInsightContainer title="Ticket Promedio Por Dia">
                  <div className="chart-container">
                    <InsightAverageTicket
                      startDate={startDate}
                      endDate={endDate}
                    />
                  </div>
                </ReportInsightContainer>
              )}
              <ReportInsightContainer title="Ventas Local VS Domicilio">
                <div className="chart-container">
                  <InsightLocalVsDelivery
                    startDate={startDate}
                    endDate={endDate}
                  />
                </div>
              </ReportInsightContainer>
              <ReportInsightContainer title="Top Productos">
                <div className="chart-container">
                  <InsightTopProducts startDate={startDate} endDate={endDate} />
                </div>
              </ReportInsightContainer>
              <ReportInsightContainer title="Top Categorías">
                <div className="chart-container">
                  <InsightTopProductCategories
                    startDate={startDate}
                    endDate={endDate}
                  />
                </div>
              </ReportInsightContainer>
              <ReportInsightContainer title="Ventas Por Productos">
                <div className="dropdown-chart">
                  <InsightProducts startDate={startDate} endDate={endDate} />
                </div>
              </ReportInsightContainer>
              <ReportInsightContainer title="Ventas Por Categoría">
                <div className="dropdown-chart">
                  <InsightCategories startDate={startDate} endDate={endDate} />
                </div>
              </ReportInsightContainer>
            </div>
          )}
        </Tab>
        <Tab eventKey="ventas" title="Ventas">
          <div className="mt-4">
            <InsightSalesTable startDate={startDate} endDate={endDate} />
          </div>
        </Tab>
        <Tab eventKey="gastos" title="Gastos">
          <div className="mt-4">
            <InsightExpensesTable startDate={startDate} endDate={endDate} />
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default ReportPage;
